import { useMemo, useRef, useState } from 'react'
import Image from 'next/image'
import classNames from 'classnames'

import { otherClients } from 'data/portfolio/index'

function LogoSlider({ className = '' }) {
  const [offset, setOffset] = useState(0)
  const clients = useMemo(
    () => Object.values(otherClients).sort((a, b) => (a.featured === b.featured ? 0 : a.featured ? -1 : 1)),
    [otherClients]
  )
  const nbClients = useMemo(() => clients.length, [clients])

  const onPrev = () => {
    setOffset((prev) => prev - 1)
  }

  const onNext = () => {
    setOffset((prev) => prev + 1)
  }

  return (
    <div className={classNames(className)}>
      <div className="relative">
        <button
          onClick={onPrev}
          className="absolute top-0 left-0 z-10 flex h-full w-10 items-center justify-start bg-backgroundLight md:-left-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-6 w-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </button>
        <button
          onClick={onNext}
          className="absolute top-0 right-0 z-10 flex h-full w-10 items-center justify-end bg-backgroundLight md:-right-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-6 w-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
          </svg>
        </button>
        <div className="mx-10 grid grid-cols-2 gap-2 md:mx-0 md:grid-cols-6 md:gap-8">
          {[0, 1, 2, 3, 4, 5].map((el) => {
            const elId = (((el + offset) % nbClients) + nbClients) % nbClients
            return (
              <div key={el} className={classNames('mr-8 flex-none overflow-hidden', { 'hidden md:block': el > 1 })}>
                <Image
                  key={elId}
                  src={clients[elId].url}
                  width={clients[elId].width}
                  height={clients[elId].height}
                  className="mix-blend-multiply"
                  placeholder="blur"
                  blurDataURL={`data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAwIiBoZWlnaHQ9IjUwMCIgdmlld0JveD0iMCAwIDUwMCA1MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjkxIiB5PSIyMDMiIHdpZHRoPSIzMTciIGhlaWdodD0iOTQiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=`}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default LogoSlider
